const en_US = {
  'join': 'Join',
  'regular': 'Regular',
  'rare': 'Rare',
  'epic': 'Epic',
  'legendary': 'Legendary',
  'no_rank': ' ',
  'genesis': 'Genesis',
  'no_nft': `Sorry, you didn't win`,
  'has_nft': 'Congrats! You won',
  'award': ' ',
  'no_mint': 'You haven’t minted APE Genesis NFT',
  'apply': 'Apply',
  'rank': 'Rank',
  'follow': 'Follow',
  'total': 'Total',
  'click_draw': 'Click to Draw',
  'section_1_p1': 'Welcome to the',
  'section_1_p3': 'Own the Genesis NFT',
  'section_1_p4': 'Become a VIP member',
  'section_2_span_1': 'What is the',
  'section_2_span_2': 'Genesis NFT?',
  'section_2_p1_1': 'Genesis NFT, a limited edition NFT minted specifically for APENFT MarketPlace, is issued in a total of ',
  'section_2_p1_2': ' pieces and is divided into four grades: regular, rare, epic and legendary. The higher the grade, the more benefits you enjoy.',
  'section_2_p2': 'Genesis NFT is a ticket to enter the APENFT VIP Club. VIP Club membership grants whitelist access for many projects in the TRON ecosystem, as well as various other exclusive benefits.',
  'section_3_rank1_p2': 'Left',
  'section_3_rank2_p2': 'Left',
  'section_3_rank3_p2': 'Left',
  'section_3_rank4_p2': 'Left',
  'section_3_rank1_title': 'Requirements to earn Regular Genesis NFT badges',
  'section_3_rank2_title': 'Requirements to earn Rare Genesis NFT badges',
  'section_3_rank3_title': 'Requirements to earn Epic Genesis NFT badges',
  'section_3_rank4_title': 'Requirements to earn Legendary Genesis NFT badges',
  'section_3_rank_text_p1': 'The user holds the following assets in TronLink wallet:',
  'section_3_rank_foot_p1_1': 'Users who hold ',
  'section_3_rank_foot_p1_2': ' worth of the assets laid out above can receive a ',
  'section_3_rank1_foot_p2': '20% of the Genesis NFTs contain $NFT worth $50',
  'section_3_rank2_foot_p2': '20% of the Genesis NFTs contain $NFT worth $200',
  'section_3_rank3_foot_p2': '20% of the Genesis NFTs contain $NFT worth $2,000',
  'section_3_rank_foot_p3': 'Block data obtained on March 1, 2022 at 0:00 a.m.(UTC) will be used for the wallet snapshot.',
  'section_3_rank4_footer_p': 'Decisions will be made through voting in the TRON DAO',
  'section_4_title_p1': 'If you don\'t have sufficient assets as required in your TronLink wallet,',
  'section_4_title_p2': 'but you belong to one of the following categories:',
  'section_4_content_p1': '· VIP Poloniex traders',
  'section_4_content_p2': '· Crypto KOLs or media outlets',
  'section_4_content_p3': '· Pre-registered users participating in the referral program',
  'section_4_content_p4': '· Users who have lost $NFT or TRX before',
  'section_4_content_p5': '· NFT artists',
  'section_4_content_p6': '· Blockchain developers',
  'section_4_button': 'Join our Discord to claim',
  'section_6_title_1': 'You can get a ',
  'section_6_title_2': 'Genesis NFT',
  'eligibility_review': 'Eligibility Review',
  'assets_date': 'Assets you hold by March 1, 2022',
  'currency': 'Digital currencies',
  'collection_hold': 'Collectibles you hold',
  'exchange_rate': 'Exchange rate',
  'rate_base': 'The rate is based on March 1',
  'value': 'Value',
  'success_p1': 'Congratulations! You passed the review.',
  'success_p2_1': 'You have chance to get a ',
  'or': ' or ',
  'success_p2_2': ' APENFT Genesis NFT.',
  'fail_p1': 'We are sorry that the record of your holdings shows that you do not meet the requirements to claim Genesis NFT badges.',
  'fail_p2': 'However, there are other ways for you to obtain Genesis NFTs. ',
  'fail_p3_1': 'Join our ',
  'fail_p3_2': ' community for more information',
  'already_p1': 'You already have a Genesis NFT.',
  'already_p2': 'The lucky draw is open to each user once only.',
  'draw_genesis': 'Draw Genesis',
  'cancel': 'Cancel',
  'already_claimed_1': 'You already have a Genesis NFT.',
  'already_claimed_2': 'The lucky draw is open to each user once only.',
  'assets_not_enough': 'You don\'t have sufficient assets as required in your TronLink wallet.',
  'contact_us': 'Contact Us',
  'footer_h5': 'You may follow the latest updates of APENFT MarketPlace, including our most up-to-date features, NFT drops, and how to use APENFT MarketPlace.',
  'footer_tail': 'Dedicated to gathering together first-rate creative artists and trending projects, as well as building a platform focusing on valuable digital artworks, APENFT.io provides top creators, well-known projects, and collectors who strive for perfection with stable, secure, and effective decentralized services.',
  'login_to_claim': 'Connect your TronLink to claim your NFT',
  'no_tronlink': 'Don\'t have TronLink?',
  'tronlink_not_login': 'TronLink not Login',
  'tronlink_not_connected': 'TronLink not Connected',
  'tronlink_not_install': 'TronLink not Installed',
  'install': 'Install',
  'congratulation': 'Congratulations! Get',
  'fail_to_claim': 'Failed to Claim',
  'hit_p1': 'Meanwhile, you will also get',
  'hit_p2': 'It will be sent to your TRC20 address in 7 business days. Please stay tuned!',
  'token': 'Token',
  'not_main_net': 'Not TRON Main Network Connected',
  'trigger_contract_failed': 'Trigger Contract Failed',
  'asset_value': ' asset value ',
  'contract_address': 'Contract Address: ',
  'refresh_to_login_1': 'If you have already logged into TronLink',
  'refresh_to_login_2': 'please refresh the page to connect',
  'wallet_connect': 'Wallet Connect',
  'to_market': "View the collection on APENFT Marketplace",

};

export default en_US